// extracted by mini-css-extract-plugin
module.exports = {"box":"View_box_1VxdL","w48":"View_w48_1DWcW"};